import React from "react";
import { Routes , Route } from 'react-router-dom';
import ArticlesPage from "../pages/articlesPage/articlesPage.container";
import AboutPage from "../pages/aboutPage/aboutPage.container";
import Experience from "../pages/experiencePage/experiencePage.container";
import Resume from "../pages/resumePage/resumePage.component";
import Article from "../pages/articlePage/articlePage.container";
import Skills from "../pages/skillsPage/skills.container";
import styles from './content.component.less'
import RSidebar from "../rsidebar/rsidebar.container";

function Content(props)
{
    return (
        <div className={styles.content}>
             <Routes>
                <Route exact path="/Articles" element={<ArticlesPage />} />
                <Route exact path="/Articles/:id" element={<Article />} />
                <Route exact path="/" element={<AboutPage />} />
                <Route exact path="/About" element={<AboutPage />} />
                <Route exact path="/Experience" element={<Experience />} />
                <Route exact path="/Resume" element={<Resume />} />
                <Route exact path="/Skills" element={<Skills />} />
            </Routes>
            <RSidebar />

        </div>
    )
}

export default Content;